// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4354":"4d37938465a1d827693d","4816":"4d37938465a1d827693d"}[chunkId] + ".min.css";
};